import { Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { DashboardComponent } from './dashboard/dashboardController';
import { MaintenancePartsComponent } from './maintenance/maintenance-parts.component';
import { MaintenanceReservationsComponent } from './maintenance/maintenance-reservations.component';
import { ScheduleMaintenanceComponent } from './maintenance/schedule-maintenance.component';
import { SelectMechanicComponent } from './maintenance/select-mechanic.component';
import { VehicleProfilesComponent } from './vehicle-profiles/vehicle-profiles.component';

export const appRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: AuthComponent, data: { mode: 'login' } },
  { path: 'register', component: AuthComponent, data: { mode: 'register' } },
  { path: 'change-credentials', component: AuthComponent, data: { mode: 'change-credentials' } },
  { path: 'vehicle-profiles', component: VehicleProfilesComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'maintenance-parts', component: MaintenancePartsComponent },
  { path: 'maintenance-reservations', component: MaintenanceReservationsComponent },
  { path: 'schedule-maintenance', component: ScheduleMaintenanceComponent },
  { path: 'select-mechanic', component: SelectMechanicComponent },
  { path: '**', redirectTo: 'login' }
];
